// tslint:disable-next-line:no-unused-expression
export enum AppEnums {
  HOME_OFFICE = 'homeOffice',
  SelectedStore = 'store',
  SavedOrder = 'savedOrder',
  GL_CODE = 'glCode',
  MIN_SEG_LENGTH = 'minSegLength'

}

export enum AppEnumsSession {
  trackingId = 'trackingId',
  SelectedStore = 'store',
  orderStatus = 'orderStatus',
  cartCount = 'cartCount'
}
